import { useAppDispatch, useAppSelector } from '@hooks';
import { Snackbar } from '@mui/material';
import { hideAlert } from '@redux/actions';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertBox } from '../AlertBox';

const AppAlert: FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { alert } = useAppSelector(state => state.app);

  const handleClose = () => {
    dispatch(hideAlert());
  };

  if (!alert.show) return null;

  return (
    <Snackbar
      open={alert.show}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      autoHideDuration={alert.type === 'success' ? 3000 : null}
      onClose={handleClose}
    >
      <div onClick={handleClose}>
        <AlertBox type={alert.type} message={t(alert.message)} showIcon />
      </div>
    </Snackbar>
  );
};

export default AppAlert;
